/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderDocumentType {
    DELIVERY_NOTE = 'DeliveryNote',
}
